import { Camera } from 'lucide-react';
import { getReviewRows } from '../helper';
import Heading from './Heading';

const Review = ({ values, carrierOptions, onEdit }) => {
  const hasCardPhoto = Boolean(values.card_front_pic || values.card_back_pic);

  return (
    <>
      <Heading
        title="Does this look right?"
        description="Have a quick read, then we'll save it to your file."
      />

      <div className="divide-y divide-gray-100 rounded-xl border border-gray-200">
        {getReviewRows(values, carrierOptions).map(({ label, value, placeholder = 'Not provided', step }) => (
          <div key={label} className="flex items-center gap-4 px-4 py-3.5 sm:px-5">
            <div className="min-w-0 flex-1 sm:flex sm:items-center sm:gap-4">
              <span className="block text-xs font-medium text-secondary-400 sm:w-36 sm:shrink-0 sm:text-sm">{label}</span>

              <span className={`block break-words text-sm sm:min-w-0 sm:truncate ${value ? 'font-bold text-secondary-900' : 'text-secondary-300'}`}>
                {value || placeholder}
              </span>
            </div>

            <button
              type="button"
              onClick={() => onEdit(step)}
              className="shrink-0 text-sm font-semibold text-secondary-600 underline underline-offset-4 transition-colors hover:text-secondary-900"
            >
              Edit
            </button>
          </div>
        ))}
      </div>

      {!hasCardPhoto && (
        <button
          type="button"
          onClick={() => onEdit('card')}
          className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl border-2 border-dashed border-gray-300 px-4 py-4 text-sm font-bold text-secondary-800 transition-colors hover:border-teamcare-blue hover:bg-blue-50/40"
        >
          <Camera size={18} />
          Add a photo of the card too
        </button>
      )}
    </>
  );
};

export default Review;
